module.exports = __webpack_public_path__ + "img/[大哭].1dcabfe1.svg";